import { useTranslation } from "react-i18next";
import styles from "../css/ColorSelectScreen.module.css";
import { IconColor } from "../model/IconColor";
import ContainerNavigationView from "../view/ContainerNavigationView";
import { ReactComponent as CloseIcon } from "../../../img/iconImgAllClose.svg";
import { ReactComponent as ColorBoxIcon } from "../../../img/iconImgAllColorBox.svg";
import { IconColorList } from "../model/IconColorList";
import { IconColorSet } from "../model/IconColorSet";
import SpacingView from "../view/SpaingView";
import ListSettingView from "../ListSettingView";
import { useBackToClose } from "../../../hooks/useBackToClose";

interface ColorSelectScreenProps {
  open: boolean;
  onSelectItem: (item: IconColor) => void;
  list: IconColorList;
  onClose: () => void;
}

export default function ColorSelectScreen(props: ColorSelectScreenProps) {
  useBackToClose(props.open, props.onClose);
  const { t } = useTranslation();

  function makeColorList(from: IconColorList): IconColor[] {
    switch (from) {
      case IconColorList.collections:
      case IconColorList.termLevel:
        return [
          IconColor.from(IconColorSet.gray),
          IconColor.from(IconColorSet.red),
          IconColor.from(IconColorSet.orange),
          IconColor.from(IconColorSet.yellow),
          IconColor.from(IconColorSet.green),
          IconColor.from(IconColorSet.mint),
          IconColor.from(IconColorSet.blue),
          IconColor.from(IconColorSet.grayishBlue),
          IconColor.from(IconColorSet.purple),
          IconColor.from(IconColorSet.pink),
        ];
    }
  }

  function handleOnClickContainer(e: React.MouseEvent<HTMLDivElement>) {
    e.stopPropagation();
  }

  function handleOnClickItem(item: IconColor) {
    props.onSelectItem(item);
    props.onClose();
  }

  const colors = makeColorList(props.list);

  if (!props.open) return null;
  return (
    <>
      <div className={styles.stack} onClick={props.onClose}>
        <div className={styles.main}>
          <div className={styles.container} onClick={handleOnClickContainer}>
            <ContainerNavigationView
              open={true}
              title={t("Colors")}
              leftImageButtonImage={CloseIcon}
              onClickLeftImageButton={props.onClose}
            />
            <SpacingView height={24} />

            <div className={styles.listContainer}>
              {colors.length > 0 &&
                colors.map((color, index) => (
                  <ListSettingView
                    key={index}
                    title={color.name}
                    leftIcon={ColorBoxIcon}
                    leftIconColor={color.color}
                    valueStyle="stringValue"
                    handleOnClick={() => {
                      handleOnClickItem(color);
                    }}
                  />
                ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
